<app-modal-dialog 
[show]="showModal" 
size="lg" 
position="top"
(closed)="closedCreateNote()"
#modal >
    <div class="modal-header" modal-header>
        <h1>Crea una Nota de Ingreso</h1>
        <h1 style="left: 0" class="i-hover">
            <i class="fa fa-xmark" (click)="closeModal(modal)"></i>
        </h1>
    </div>
    <div class="modal-body" modal-body>
        <div class="row mb-4">

            <div class="col-6 form-group mb-4">
                <label for="provider-note" class="form-label">Proveedor<span
                    class="required">*</span></label>
                <div class="input-group">
                    <app-input-autocomplete [allBorderRadius]="true" [inputs]="inputs.provider"
                        [placeholder]="'Ingresa un Proveedor'" [filterElements]="filterProviders"
                        [typeElements]="'provider-note'" (inputMethod)="writeProvider($event.event)"
                        (changeStatus)="checkProvider($event.filterElement)"
                        (getTitle)="
                            $event.filterElement.title =
                                $event.filterElement.code +
                                ' - ' +
                                $event.filterElement.name
                        "
                        ></app-input-autocomplete>
                </div>
            </div>

            

            <!-- Fecha de entrada -->
            <div class="col-sm-6 form-group mb-4">
                <label for="entryDate" class="form-label">Fecha de Ingreso<span>*</span></label>
                <input
                type="datetime-local"
                [ngModel]="entryNoteData.entryDate | date: 'yyyy-MM-ddTHH:mm'"
                (ngModelChange)="entryNoteData.entryDate = $event"
                name="entryDate"
                id="entryDate"
                class="form-control"
                />
            </div>

            <!-- Descripción -->
            <div class="col-sm-6 form-group mb-4">
                <label for="transactionDescription" class="form-label">Transacción</label>
                <textarea
                [(ngModel)]="entryNoteData.transactionDescription"
                name="transactionDescription"
                id="transactionDescription"
                class="form-control"
                rows="1"
                placeholder="Ej: Compra de materia prima"
                ></textarea>
            </div>

            <!-- Ticket báscula -->
            <!-- <div class="col-sm-6 form-group mb-4">
                <label for="scaleTicketNumber" class="form-label">Boleta Bascula No.</label>
                <input
                type="text"
                [(ngModel)]="entryNoteData.scaleTicketNumber"
                name="scaleTicketNumber"
                id="scaleTicketNumber"
                class="form-control"
                placeholder="Ej: ST-2025-001"
                />
            </div> -->
            <div class="col-6 form-group mb-4">
                <label for="scale-note" class="form-label">Boleta Bascula No.r<span
                    class="required">*</span></label>
                <div class="input-group">
                    <app-input-autocomplete [allBorderRadius]="true" [inputs]="inputs.scales"
                        [placeholder]="'Seleccion una Boleta'" [filterElements]="filterScales"
                        [typeElements]="'scale-note'" (inputMethod)="writeScale($event.event)"
                        (changeStatus)="checkScale($event.filterElement)"
                        (getTitle)="
                            $event.filterElement.title = $event.filterElement.noteNumber
                        "
                        ></app-input-autocomplete>
                </div>
            </div>


            <div class="col-sm-4 form-group mb-4">
                <label for="product-order" class="form-label">Producto</label>
                <div class="input-group">
                    <app-input-autocomplete
                        [allBorderRadius]="true"
                        [inputs]="inputs.product"
                        [placeholder]="'Ingresa un producto'"
                        [filterElements]="filterProducts"
                        [typeElements]="'product-order'"
                        (inputMethod)="writeProduct($event.event)"
                        (changeStatus)="checkProduct($event.filterElement)"
                        (getTitle)="
                            $event.filterElement.title =
                                $event.filterElement.code +
                                ' - ' +
                                $event.filterElement.name
                        "
                    ></app-input-autocomplete>
                </div>
            </div>
            <div class="col-sm-4 form-group mb-4" >
                <label for="quantity" class="form-label">Cantidad Solicitada</label>
                <div class="input-group">
                    <input
                        type="number"
                        name="quantity"
                        id="quantity"
                        [(ngModel)]="quantity"
                        class="form-control"
                    />
                </div>
            </div>
            <div class="col-sm-4 form-group mb-4" >
                <label for="quantityReceived" class="form-label">Cantidad Recibida</label>
                <div class="input-group">
                    <input
                        type="number"
                        name="quantityReceived"
                        id="quantityReceived"
                        [(ngModel)]="quantityReceived"
                        class="form-control"
                    />
                    <button
                        class="btn btn-primary"
                        (click)="addProduct()"
                        title="Agregar producto"
                        [disabled]="!inputs.product.verified || quantity <= 0 || quantityReceived <= 0"
                    >
                        <span class="superposition-container">
                            <i class="fa fa-boxes"></i>
                            <i
                                style="color: yellow"
                                class="fa fa-plus superposition-element"
                            ></i>
                        </span>
                    </button>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="productList.length > 0">
            <div class="col">
                <div class="table-responsive table-bordered">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th>Producto</th>
                                <th class="td-center bg-info-subtle">Unidad/Item</th>
                                <th class="text-right bg-warning-subtle">Cantidad</th>
                                <th class="text-right ">Cantidad Recibida</th>
                                <th class="td-center">Opciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor=" let product of productList; let i = index">
                                <td>
                                    {{ product.productData.code }} -
                                    {{ product.productData.name }}
                                </td>
                                <td class="td-center bg-info-subtle">
                                    {{ product.item }}
                                </td>
                                <td class="text-right bg-warning-subtle">
                                    {{ product.quantity }}
                                </td>
                                <td class="text-right">
                                    {{ product.quantityReceived }}
                                </td>
                                <td class="td-center">
                                    <span class="text-danger a-hover" 
                                    tooltip="Eliminar"
                                    (click)="removeProduct(i)">
                                        <i class="fa fa-trash"></i>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <!-- Piloto -->
            <div class="col-sm-6 form-group">
                <label for="pilotName" class="form-label">Nombre del piloto</label>
                <input
                type="text"
                [(ngModel)]="entryNoteData.pilotName"
                name="pilotName"
                id="pilotName"
                class="form-control"
                placeholder="Ej: Juan Pérez"
                />
            </div>

            <!-- Placa cabezal -->
            <div class="col-sm-6 form-group">
                <label for="headLicensePlate" class="form-label">Cabezal Placa</label>
                <input
                type="text"
                [(ngModel)]="entryNoteData.headLicensePlate"
                name="headLicensePlate"
                id="headLicensePlate"
                class="form-control"
                placeholder="Ej: ABC-123"
                />
            </div>

            <!-- Placa tanque -->
            <div class="col-sm-6 form-group">
                <label for="tanketLicensePlate" class="form-label">Cisterna Placa</label>
                <input
                type="text"
                [(ngModel)]="entryNoteData.tanketLicensePlate"
                name="tanketLicensePlate"
                id="tanketLicensePlate"
                class="form-control"
                placeholder="Ej: XYZ-987"
                />
            </div>

        </div>

        <div class="row mt-4">
            <div class="d-flex justify-center">
                <button class="btn btn-success" (click)="createNote()"
                    [disabled]="loading || !inputs.provider.verified || !date || productList.length == 0 || currentProvider==null ">
                    <ng-container *ngIf="!loading">
                        <i class="fa fa-floppy-disk"></i>
                    </ng-container>
                    <ng-container *ngIf="loading">
                        <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                        <span role="status"></span>
                    </ng-container>GUARDAR
                </button>
            </div>
	    </div>
    </div>
    <!-- <div class="modal-footer" modal-footer>
		<button class="btn btn-success" (click)="createNote()"
			[disabled]="loading || !inputs.provider.verified || !inputs.client.verified || !date || productList.length == 0 || currentClient==null">
			<ng-container *ngIf="!loading">
				<i class="fa fa-floppy-disk"></i>
			</ng-container>
			<ng-container *ngIf="loading">
				<span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
				<span role="status"></span>
			</ng-container>GUARDAR
		</button>
	</div> -->
</app-modal-dialog> 